
import { changePasswordApi, getUserProfileApi, managerFirstChangePasswordApi, userLoginApi } from "../components/constant/api";
import { myApi } from "./api";

export const userApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    setUserLogin: builder.mutation({
      query: (post) => ({
        url: userLoginApi,
        method: "POST",
        body:post
      }),
    }),
    updateFirstPassword: builder.mutation({
      query: (post) => ({
        url: managerFirstChangePasswordApi,
        method: "POST",
        body:post
      }),
    }),
    getUserProfile: builder.query({
      query: () => ({
        url: getUserProfileApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? {} : {};
      },
      providesTags: (_) => ["user"],
    }),
    setChangePassword: builder.mutation({
      query: (post) => ({
        url: changePasswordApi,
        method: "POST",
        body: post,
      }),
    }),
  }),
});

export const {useSetUserLoginMutation,useGetUserProfileQuery,useUpdateFirstPasswordMutation,useSetChangePasswordMutation} = userApi;